exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-clickable:hover{\n\tbox-shadow:0 .125rem 0 0 #40739e;\n\tborder:1px solid #40739e;\n\tcursor:pointer;\n\ttext-decoration:none;\n\ttransform:translateY(-2px);\n\ttransition:border .2s ease,transform .2s ease;\n}\n\n.pointer{\n\tcursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/branch/branch.component.css
// module id = ../../../../../src/app/branch/branch.component.css
// module chunks = main